import { render, staticRenderFns } from "./info_card.vue?vue&type=template&id=c48a2d8c&scoped=true"
import script from "./info_card.vue?vue&type=script&lang=js"
export * from "./info_card.vue?vue&type=script&lang=js"
import style0 from "./info_card.vue?vue&type=style&index=0&id=c48a2d8c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48a2d8c",
  null
  
)

export default component.exports